import React, { useId } from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, NavLink, FormGroup, Label } from "reactstrap";
import { Circles } from "react-loader-spinner";
import MediaViewer from "../common/MediaViewer";
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { useTranslation } from "react-i18next";

const GenericDropdown = ({ children, items, onItemSelect, caret = true, iconClass, iconLabel, iconAlert, style, label, readOnly }) => {
    const { t } = useTranslation();
    const uniqueId = useId();
    const placeholder = <Circles width="25" height="25" ariaLabel="loading animation" wrapperClass="mt-1" />;
    
    return (
        <UncontrolledDropdown id={uniqueId} nav={caret} style={style} className="dropup" disabled={readOnly}>
            <DropdownToggle caret={false && caret} color="default" nav onClick={(e) => e.preventDefault()} className="text-center w-100">
                {children}
                {iconLabel && 
                    <>
                        {iconAlert && 
                            <div className="notification d-none d-lg-block d-xl-block" />
                        }
                        <i className={iconClass} />
                        <p className="d-lg-none">{iconLabel}</p>
                    </>
                }
                {caret &&
                    <b className="caret d-none d-lg-block d-xl-block" />
                }
            </DropdownToggle>
            <DropdownMenu 
                style={{
                    minHeight: items.length > 3 ? "17em" : "8em",
                    maxHeight: "14em", // Set your desired max height
                    overflowY: "auto",  // Enable vertical scrolling
                }}
                className="dropdown-navbar" end tag="ul">
                {items.map((item, index) => (
                    <React.Fragment key={index}>
                        {item.isDivider && <DropdownItem divider tag="li" />}
                        <NavLink tag="li">
                            <DropdownItem onClick={() => onItemSelect(item)} className="nav-item">{t(item.label || item.value)}</DropdownItem>
                        </NavLink>
                    </React.Fragment>
                ))}
            </DropdownMenu>
            {label && <Label for={uniqueId} className="text-center w-100">{label}</Label>}
        </UncontrolledDropdown>
    );
};

export default GenericDropdown;
